export default __webpack_public_path__ + "media/images/features/ja/vege_1-f1049181e0228a516c4399905f561be1.png";